import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useFormatter } from 'js/hooks/useFormatter';
import { IDynamicBalanceInfo, IMoneyInfo } from 'js/hooks/socket/types';

import * as actions from '../store/actions';

export const useUpdateUserBalance = () => {
    const dispatch = useDispatch();
    const formatter = useFormatter();

    return useCallback((serverBalances: IDynamicBalanceInfo[]): void => {
        const balances = serverBalances.reduce((acc: Record<string, IMoneyInfo>, balance) => {
            acc[balance.balanceType] = balance.balance;

            return acc;
        }, {});
        const casinoGamingBalance = balances?.casino_gaming_balance || {};
        const { amount: totalAmount, currencyCode } = casinoGamingBalance;
        const formattedBalance = formatter.formatCurrency(totalAmount, { currencyCode });

        dispatch(actions.userSetAttributesAction({
            balance: {
                balances,
                totalAmount,
                formattedBalance
            }
        }));
    }, [dispatch, formatter]);
};
